import template from './pipelineApplicationFilter.html';

export default {
  template,
  bindings: {
    pipelineType: '<',
    pipelineTypes: '<',
    isCorporateUser: '<',
    settings: '<',
    statusListRadio: '<',
    advisersList: '<',
    filterColumns: '<',
    onHideShowColumn: '&',
    labelsList: '<',
    enquirySourceList: '<',
    referrerList: '<',
    activeRangeIndex: '<',
    displayFilterDate: '<',
    selectedRange: '<',
    filterRange: '<',
    pipelineSharedData: '<',
    assistantAdviserList: '<',
    showAssistantFilter: '<',
    onCalendarUpdated: '&',
    onRangeSelected: '&',
    onChangeSettings: '&',
    onChangeStatusSettings: '&',
  },
};
